<div class="content">
    <p>Ao enviar essa solicitação, estou de acordo com a minha responsabilidade em fornecer informações que estejam
        condizentes com a realidade do veículo em questão, aceitando os eventuais ônus de operação caso haja
        divergências, como descrito nos <b (click)="showPrivacyPolicy()" class="underline cursor-pointer">Termos
            de Uso</b>
    </p>

    <p>Deseja continuar ?</p>
    <div class="buttons mt-6">
        <button (click)="closeModal()" pButton type="button" label="Não" icon="pi pi-times" iconPos="left"
            class="p-button-outlined mr-3"></button>
        <button (click)="approveVehicle()" pButton type="button" label="Sim" icon="pi pi-check" iconPos="left"
            class="p-button-label"></button>
    </div>
</div>